module.exports = __webpack_public_path__ + "static/media/sv.20aad359.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sv.svg
// module id = 255
// module chunks = 0